import React, { useState } from 'react';
import { FiSearch, FiRefreshCw } from 'react-icons/fi';
import AdminNavbar from './AdminNavbar';
import AdminSidebar from './AdminSidebar';
import ReviewsTable from './review/ReviewsTable';

const AdminReviewManage = () => {
  const [activeTab, setActiveTab] = useState('all');
  const [selectedReview, setSelectedReview] = useState(null);
  const [showReviewDetails, setShowReviewDetails] = useState(false);

  const handleViewReview = (review) => {
    setSelectedReview(review);
    setShowReviewDetails(true);
  };

  const handleBackToList = () => {
    setShowReviewDetails(false);
    setSelectedReview(null);
  };

  const handleStatusUpdate = async (reviewId, newStatus) => {
    // API call would go here in a real application
    console.log(`Review ${reviewId} status updated to ${newStatus}`);
  };

  const handleRefresh = () => {
    // Implement refresh logic here
    console.log("Refreshing reviews...");
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <AdminNavbar />
      <div className="flex">
        <AdminSidebar />
        <main className="flex-1 p-6 overflow-x-hidden">
          <h1 className="text-2xl font-bold mb-6">Reviews Management</h1>
          
          <div className="bg-white rounded-lg shadow overflow-hidden">
            <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center">
              <h2 className="text-xl font-semibold text-gray-800">Customer Reviews</h2>
              <div className="flex space-x-2">
                <button 
                  onClick={handleRefresh}
                  className="flex items-center px-3 py-2 bg-gray-100 rounded-md hover:bg-gray-200"
                >
                  <FiRefreshCw className="mr-2" /> Refresh
                </button>
              </div>
            </div>

            <div className="px-6 py-4 border-b border-gray-200">
              <div className="flex space-x-4">
                <button
                  onClick={() => setActiveTab('all')}
                  className={`px-4 py-2 rounded-md ${activeTab === 'all' ? 'bg-indigo-100 text-indigo-700' : 'hover:bg-gray-100'}`}
                >
                  All Reviews
                </button>
              </div>
            </div>

            <div className="p-6">
              {showReviewDetails ? (
                <div className="bg-white p-6 rounded-lg shadow">
                  <button 
                    onClick={handleBackToList}
                    className="mb-4 px-3 py-1 bg-gray-100 rounded-md hover:bg-gray-200"
                  >
                    ← Back to list
                  </button>
                  <div className="border rounded-lg p-6">
                    <h3 className="text-lg font-semibold mb-4">Review Details</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div>
                        <h4 className="font-medium text-gray-700">Reviewer</h4>
                        <p className="mt-1">{selectedReview?.name}</p>
                      </div>
                      <div>
                        <h4 className="font-medium text-gray-700">Email</h4>
                        <p className="mt-1">{selectedReview?.email}</p>
                      </div>
                      <div>
                        <h4 className="font-medium text-gray-700">Rating</h4>
                        <div className="flex items-center mt-1">
                          {[...Array(5)].map((_, i) => (
                            <svg
                              key={i}
                              className={`h-5 w-5 ${i < Math.floor(selectedReview?.rating) ? 'text-yellow-400' : 'text-gray-300'}`}
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                              fill="currentColor"
                            >
                              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                            </svg>
                          ))}
                          <span className="ml-2">{selectedReview?.rating.toFixed(1)}</span>
                        </div>
                      </div>
                      <div>
                        <h4 className="font-medium text-gray-700">Status</h4>
                        <select
                          value={selectedReview?.status}
                          onChange={(e) => handleStatusUpdate(selectedReview.id, e.target.value)}
                          className="mt-1 px-3 py-1 border rounded-md"
                        >
                          <option value="active">Active</option>
                          <option value="pending">Pending</option>
                          <option value="rejected">Rejected</option>
                        </select>
                      </div>
                      <div className="md:col-span-2">
                        <h4 className="font-medium text-gray-700">Comment</h4>
                        <p className="mt-1 whitespace-pre-line">{selectedReview?.comment}</p>
                      </div>
                      <div className="md:col-span-2">
                        <h4 className="font-medium text-gray-700">Review Image</h4>
                        {selectedReview?.image && (
                          <img 
                            src={selectedReview.image} 
                            alt="Review" 
                            className="mt-2 max-w-xs rounded-md border"
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <ReviewsTable 
                  onViewReview={handleViewReview}
                  onStatusUpdate={handleStatusUpdate}
                  defaultStatusFilter={activeTab === 'all' ? 'all' : activeTab}
                />
              )}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminReviewManage;